import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

export type CategoryItemType = {
  id: string;
  name: string;
  uri: string;
  parentId: string;
  mainParentId: string;
  children?: CategoryItemType[];
};

export const getCategories = async (
  locale: string,
  httpClient: HttpClientFactory,
): Promise<CategoryItemType[]> => {
  try {
    const response = await httpClient
      .getInstance()
      .get<{ categories: CategoryItemType[] }>(`${clientTopology.categoriesUrl}?locale=${locale}`);
    return response.data.categories;
  } catch (error) {
    logger.error({
      message: 'failed to fetch get all categories',
      error,
    });
    console.error(error);
    throw error;
  }
};
